const ignorarIDGeral = [137];

export default ignorarIDGeral;